import '../../../styles/aida-base.css';
import config from '../../../config.json';

/**
 * AidaFooter Component
 * New footer design from AidasCopy - Black background with links
 * Mobile-responsive with stacked layout on small screens
 */
export const AidaFooter = () => {
  return (
    <footer
      className="w-full bg-black"
      style={{
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        paddingBottom: '20px',
        paddingTop: '0px',
      }}
    >
      {/* Desktop Footer */}
      <div className="mx-auto hidden lg:flex" style={{ width: '100%', justifyContent: 'center', padding: '0 60px' }}>
        <div style={{ position: 'relative', width: '1024px', minHeight: '130px' }}>
          {/* Logo and Copyright Container */}
          <div style={{ position: 'absolute', left: '200px', top: '50px', width: '280px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {/* Logo */}
          <img
            src="/img/aida/footer-logo.png"
            alt="Playcast Logo"
            style={{
              width: '280px',
              height: '33px',
              opacity: 1,
              objectFit: 'contain',
            }}
          />

          {/* Copyright */}
          <div
            style={{
              marginTop: '7px',
              fontFamily: 'Roboto, sans-serif',
              fontSize: '13px',
              lineHeight: '26px',
              fontWeight: 400,
              color: 'rgba(255, 255, 255, 1)',
              textAlign: 'center',
            }}
          >
            © Playcast. All Rights Reserved.
          </div>
        </div>

        {/* Website Links */}
        <div
          style={{
            position: 'absolute',
            left: '560px',
            top: '50px',
            fontFamily: 'Inter, sans-serif',
            fontSize: '14px',
            lineHeight: '20px',
            fontWeight: 400,
            letterSpacing: '-0.5px',
            color: 'rgba(255, 255, 255, 1)',
          }}
        >
          <span style={{ fontWeight: 700 }}>Website  </span>
          <span style={{ fontWeight: 400 }}>—  </span>
          <a
            href="/privacy-policy"
            target="_self"
            rel="noopener noreferrer"
            className="aida-link"
            style={{
              fontSize: '14px',
              textDecoration: 'none',
              color: 'rgba(255, 255, 255, 1)',
            }}
          >
            Privacy Policy
          </a>
          <span> · </span>
          <a
            href="/terms-of-service"
            target="_self"
            rel="noopener noreferrer"
            className="aida-link"
            style={{
              fontSize: '14px',
              textDecoration: 'none',
              color: 'rgba(255, 255, 255, 1)',
            }}
          >
            Terms of Service
          </a>
          <span>  ·  </span>
          <a
            href="/eula"
            target="_self"
            rel="noopener noreferrer"
            className="aida-link"
            style={{
              fontSize: '14px',
              textDecoration: 'none',
              color: 'rgba(255, 255, 255, 1)',
            }}
          >
            EULA
          </a>
        </div>

        {/* Social Links */}
        <div
          style={{
            position: 'absolute',
            left: '560px',
            top: '74px',
            fontFamily: 'Inter, sans-serif',
            fontSize: '14px',
            lineHeight: '20px',
            fontWeight: 400,
            letterSpacing: '-0.5px',
            color: 'rgba(255, 255, 255, 1)',
          }}
        >
          <span style={{ fontWeight: 700 }}>Socials   </span>
          <span style={{ fontWeight: 400 }}>—  </span>
          <a
            href={config.DISCORD_URL}
            target="_self"
            rel="noopener noreferrer"
            className="aida-link"
            style={{
              fontSize: '14px',
              textDecoration: 'none',
              color: 'rgba(255, 255, 255, 1)',
            }}
          >
            Discord
          </a>
          <span>  ·  </span>
          <a
            href="https://www.youtube.com/@PlaycastIo"
            target="_self"
            rel="noopener noreferrer"
            className="aida-link"
            style={{
              fontSize: '14px',
              textDecoration: 'none',
              color: 'rgba(255, 255, 255, 1)',
            }}
          >
            Youtube
          </a>
          <span>  ·  </span>
          <a
            href="https://www.tiktok.com/@playcastdotio?_t=ZT-90Q0Y3yGu7R&_r=1"
            target="_self"
            rel="noopener noreferrer"
            className="aida-link"
            style={{
              fontSize: '14px',
              textDecoration: 'none',
              color: 'rgba(255, 255, 255, 1)',
            }}
          >
            Tiktok
          </a>
        </div>

          {/* Spacer for absolute positioning */}
          <div style={{ height: '130px', width: '100%' }}></div>
        </div>
      </div>

      {/* Mobile Footer */}
      <div className="mx-auto flex lg:hidden" style={{ width: '100%', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '24px', paddingTop: '40px', paddingBottom: '20px' }}>
        {/* Logo */}
        <div className="flex items-center justify-center">
          <img
            src="/img/aida/footer-logo.png"
            alt="Playcast Logo"
            style={{
              width: '240px',
              height: 'auto',
              opacity: 1,
              objectFit: 'contain',
            }}
          />
        </div>

        {/* Copyright */}
        <div
          className="flex items-center justify-center text-center"
          style={{
            fontFamily: 'Roboto, sans-serif',
            fontSize: '12px',
            lineHeight: '18px',
            fontWeight: 400,
            color: 'rgba(255, 255, 255, 1)',
            marginTop: '-12px',
          }}
        >
          © Playcast. All Rights Reserved.
        </div>

        {/* Website Section - Vertically Stacked */}
        <div className="flex flex-col items-center justify-center gap-3 text-center" style={{ marginTop: '8px' }}>
          <span
            style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '16px',
              fontWeight: 700,
              letterSpacing: '0px',
              color: 'rgba(255, 255, 255, 1)',
            }}
          >
            Website
          </span>
          <div
            className="flex flex-col items-center justify-center gap-2"
            style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '14px',
              lineHeight: '22px',
              fontWeight: 400,
              letterSpacing: '0px',
              color: 'rgba(255, 255, 255, 1)',
            }}
          >
            <a
              href="/privacy-policy"
              target="_self"
              rel="noopener noreferrer"
              className="aida-link"
              style={{
                fontSize: '14px',
                textDecoration: 'none',
                color: 'rgba(255, 255, 255, 1)',
              }}
            >
              Privacy Policy
            </a>
            <a
              href="/terms-of-service"
              target="_self"
              rel="noopener noreferrer"
              className="aida-link"
              style={{
                fontSize: '14px',
                textDecoration: 'none',
                color: 'rgba(255, 255, 255, 1)',
              }}
            >
              Terms of Service
            </a>
            <a
              href="/eula"
              target="_self"
              rel="noopener noreferrer"
              className="aida-link"
              style={{
                fontSize: '14px',
                textDecoration: 'none',
                color: 'rgba(255, 255, 255, 1)',
              }}
            >
              EULA
            </a>
          </div>
        </div>

        {/* Socials Section - Vertically Stacked */}
        <div className="flex flex-col items-center justify-center gap-3 text-center">
          <span
            style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '16px',
              fontWeight: 700,
              letterSpacing: '0px',
              color: 'rgba(255, 255, 255, 1)',
            }}
          >
            Socials
          </span>
          <div
            className="flex flex-col items-center justify-center gap-2"
            style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '14px',
              lineHeight: '22px',
              fontWeight: 400,
              letterSpacing: '0px',
              color: 'rgba(255, 255, 255, 1)',
            }}
          >
            <a
              href={config.DISCORD_URL}
              target="_self"
              rel="noopener noreferrer"
              className="aida-link"
              style={{
                fontSize: '14px',
                textDecoration: 'none',
                color: 'rgba(255, 255, 255, 1)',
              }}
            >
              Discord
            </a>
            <a
              href="https://www.youtube.com/@PlaycastIo"
              target="_self"
              rel="noopener noreferrer"
              className="aida-link"
              style={{
                fontSize: '14px',
                textDecoration: 'none',
                color: 'rgba(255, 255, 255, 1)',
              }}
            >
              Youtube
            </a>
            <a
              href="https://www.tiktok.com/@playcastdotio?_t=ZT-90Q0Y3yGu7R&_r=1"
              target="_self"
              rel="noopener noreferrer"
              className="aida-link"
              style={{
                fontSize: '14px',
                textDecoration: 'none',
                color: 'rgba(255, 255, 255, 1)',
              }}
            >
              Tiktok
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
